const InlineSpace = ({ width }) => {
  return (
    <span style={{ marginLeft: width }}></span>
  );
};

export default InlineSpace;
